import useLanguage from '@hooks/useLanguage.hook'
import { useAxios } from './useAuthorizedAxios'

type AddCustomerWhitelistParams = {
    plate: string
    country: string
    email?: string
}

type SendEmailParams = {
    plate: string
    email: string
}

export const useCustomerAPI = () => {
    const axios = useAxios()
    const [lng] = useLanguage()

    const addCustomerWhitelist = ({ plate, country, email }: AddCustomerWhitelistParams) => {
        return axios.post(`${process.env.VITE_API_URL}customer/whitelist`, {
            plate,
            country,
            email: email || undefined
        })
    }

    const sendEmail = ({ plate, email }: SendEmailParams) => {
        const emailLng = lng.toUpperCase().split('-')[0]
        return axios.post(`${process.env.VITE_API_URL}customer/enque-email`, {
            to: [email],
            mail_variables: {
                plate,
                language: emailLng
            }
        })
    }

    return {
        addCustomerWhitelist,
        sendEmail
    }
}
